import { useMutation } from '@tanstack/react-query'
import { IMilkingScheduleResponse } from 'models/MilkingProcess'

import MilkingProcessService from 'services/milkingProcessService'
import { useAppDispatch } from 'store/hooks'

import { AxiosError } from 'axios'
import { notifyUser } from 'store/notificationsSlice'
import { getErrorMessage } from 'utils/getErrorMessage/getErrorMessage'
import { IMilkingForm } from '../types/milkingForm'

export const useMilkingScheduleMutation = () => {
	const dispatch = useAppDispatch()

	return useMutation<void, AxiosError, IMilkingForm>({
		mutationFn: async (form: IMilkingForm) => {
			const hallsMap: Record<string, IMilkingScheduleResponse> = {}

			for (const shift of ['am', 'pm', 'night'] as const) {
				const part = form[shift]
				for (const hall of part.halls) {
					if (!hallsMap[hall.milk_hall]) {
						hallsMap[hall.milk_hall] = {
							milk_hall: hall.milk_hall,
							am_allowed_deviation_seconds:
								Number(form.am_allowed_deviation_seconds) * 60,
							pm_allowed_deviation_seconds:
								Number(form.pm_allowed_deviation_seconds) * 60,
							night_allowed_deviation_seconds:
								Number(form.night_allowed_deviation_seconds) * 60,
							am_period_start: '',
							am_period_end: '',
							pm_period_start: '',
							pm_period_end: '',
							night_period_start: '',
							night_period_end: '',
						}
					}
					hallsMap[hall.milk_hall][`${shift}_period_start`] = hall.start
					hallsMap[hall.milk_hall][`${shift}_period_end`] = hall.end
				}
			}

			const adaptedData = Object.values(hallsMap)

			await Promise.all(
				adaptedData.map(item =>
					MilkingProcessService.updateMilkingSchedule(item),
				),
			)
		},

		onSuccess: () => {
			dispatch(
				notifyUser({
					title: 'Данные успешно сохранены',
					description: 'Изменения применены.',
					isError: false,
				}),
			)
		},

		onError: error => {
			const errorMsg = getErrorMessage(error?.response?.data)
			dispatch(
				notifyUser({
					title: 'Не удалось изменить расписание',
					description: errorMsg,
					isError: true,
				}),
			)
		},
	})
}
